import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import {
  SoilAnalysis,
  GetSoilAnalysesResponse,
  ManualSoilAnalysis,
} from '../models/soil-analysis.model';

@Injectable({
  providedIn: 'root',
})
export class SoilAnalysisApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/fieldregistration/soilanalysis';

  fetchSoilAnalyses(cropYear: number): Observable<SoilAnalysis[]> {
    return this.http
      .get<GetSoilAnalysesResponse>(`${this.baseUrl}/year/${cropYear}`)
      .pipe(map((response) => response.soilAnalyses));
  }

  fetchManualSoilAnalysis(id: number): Observable<ManualSoilAnalysis> {
    return this.http.get<ManualSoilAnalysis>(`${this.baseUrl}/manual/${id}`);
  }

  upsertManualSoilAnalysis(soilAnalysis: ManualSoilAnalysis) {
    return this.http
      .post<{ id: number }>(`${this.baseUrl}/manual`, soilAnalysis)
      .pipe(map((response) => response.id));
  }

  fetchDefaultSoilAnalyses() {
    return this.http
      .get<GetSoilAnalysesResponse | SoilAnalysis[]>(`${this.baseUrl}/default`)
      .pipe(map((response) => (Array.isArray(response) ? response : response.soilAnalyses)));
  }
}
